import React from 'react'
import Employeeimage from "./employeeTracker.jpeg"

export default function Employeetracker() {
  return (
    <img className ="w-64 m-auto rounded-lg hover:w-96 hover:ease-in duration-300" src={Employeeimage}></img>
  )
}
